import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "waiting-room-selector" }
const _hoisted_2 = { class: "row w-full mbottom-10" }

import { onMounted, ref, watch } from "vue";
import {InstituteApi, WaitingRoomResponse} from "@/apiGenerate/medserver";
import {ItemSelect} from "@/models/share.model";
import {medServerApiConfig} from "@/config/medserver-api.config";
import {useI18n} from "vue-i18n";
import {useWaitingRoomsStore} from "@/stores/waitingRooms";
import AutoComplete, { AutoCompleteCompleteEvent } from 'primevue/autocomplete';
import { useDebounceFn } from "@vueuse/core";


export default /*@__PURE__*/_defineComponent({
  __name: 'EsWaitingRoomSelector',
  props: {
    roomId: {},
    roomName: {},
    fromAgenda: { type: Boolean, default: false }
  },
  emits: ["selectRoomEvent"],
  setup(__props: any, { emit: __emit }) {


const props = __props;


const emit = __emit;
const {t} = useI18n();
const instituteApi = new InstituteApi(medServerApiConfig);

const waitingRooms = ref<ItemSelect[]>([]);
const waitingRoom = ref<ItemSelect>(null);

const filteredWaitingRoom = ref<ItemSelect[]>([]);

const debouncedSearchWaitingRoom = useDebounceFn((event: AutoCompleteCompleteEvent) => {
  searchWaitingRoom(event);
}, 500);

const searchWaitingRoom = (event: AutoCompleteCompleteEvent) => {
    if (!event.query.trim().length) {
      filteredWaitingRoom.value = [...waitingRooms.value];
    } else {
      filteredWaitingRoom.value = waitingRooms.value.filter((waitingRoom) => {
        return waitingRoom.label.toLowerCase().includes(event.query.toLowerCase())
      });
    }
}

onMounted(async () => {
  const id = useWaitingRoomsStore().currentInstitute;

  instituteApi.listRoomsByInstitute({instituteId: id, withTemporary: true}).then(response => {
    waitingRooms.value = response.map((room: WaitingRoomResponse) => ({
              id: room.roomId,
              label: room.name
            } as ItemSelect));
    if (props.roomId) {
      let room = response.find((r) => r.roomId === props.roomId);
      if (!room) return;
      waitingRoom.value = {id: room.roomId, label: room.name} as ItemSelect;
    } else if (props.roomName) {
      let room = response.find((r) => r.name === props.roomName);
      if (room) {
        waitingRoom.value = {id: room.roomId, label: room.name} as ItemSelect;
      } else {
        waitingRoom.value = {id: undefined, label: props.roomName} as ItemSelect;
        filteredWaitingRoom.value.push(waitingRoom.value);
      }
    }
  });
});

watch(
    () => props.roomName,
  async () => {
    if (filteredWaitingRoom.value) {
      let room = filteredWaitingRoom.value.find((r) => r.label === props.roomName);
        if (room) {
          waitingRoom.value = {id: room.id, label: room.label} as ItemSelect;
        } else {
          waitingRoom.value = {id: undefined, label: props.roomName} as ItemSelect;
          filteredWaitingRoom.value.push(waitingRoom.value);
        }
    }    
  }
);

watch(
    () => props.roomId,
  async () => {
    if (filteredWaitingRoom.value) {
      let room = filteredWaitingRoom.value.find((r) => r.id === props.roomId);
        if (room) {
          waitingRoom.value = {id: room.id, label: room.label} as ItemSelect;
        }
    }    
  }
);

watch(
  () => waitingRoom.value,
  () => {
    emit('selectRoomEvent', {
    roomId: waitingRoom.value.id ?? undefined,
    customRoomName: waitingRoom.value.label ?? waitingRoom.value
  });
  }
)

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([props.fromAgenda ? 'col-0-12' : 'col-0-8', 'colend mright-04'])
      }, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('calendar.waiting.room.location'),
          styles: "main-m"
        }, null, 8, ["txt"])
      ], 2),
      _createVNode(_unref(AutoComplete), {
        class: "w-full",
        modelValue: waitingRoom.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((waitingRoom).value = $event)),
        suggestions: filteredWaitingRoom.value,
        optionLabel: "label",
        onComplete: _cache[1] || (_cache[1] = ($event: any) => (_unref(debouncedSearchWaitingRoom)($event))),
        size: "small",
        dropdown: "",
        delay: 50
      }, null, 8, ["modelValue", "suggestions"])
    ])
  ]))
}
}

})